<template>
  <div class="wf-self-end wf-w-full">
    <div class="wf-w-full wf-flex wf-items-center wf-justify-center" :class="elementClasses" :style="elementStyles">
      <div @keydown.enter.prevent @input="text = $event.target.textContent" contenteditable class="focus:wf-outline-none wf-uppercase wf-font-bold wf-tracking-wide" v-text="text"></div>
    </div>
  </div>
</template>

<script>
  import _ from 'lodash'
  import {StylesParser} from '../StylesParser'
  import {ConstantsParser} from '../ConstantsParser'
  import ArrayManipulation from '../mixins/ArrayManipulation'
  export default {
    mixins: [ArrayManipulation],
    props: {
      classes: {
        type: [Object],
        required: true,
      },
      styles: {
        type: [Object],
        required: true,
      },
    },
    computed: {
      device() {
        return this.parent.device
      },
      id() {
        return this.$vnode.key
      },
      parent() {
        return this.$parent.$parent
      },
      content() {
        return this.parent.components.find(formComponent => formComponent.id == this.id).content
      },
      formRowId() {
        return this.parent.parent.id
      },
      formColumnId() {
        return this.parent.id
      },
      formElement() {
        return this.parent.formElement
      },
      form() {
        return this.$store.getters['componentModule/elements'](this.formElement)
      },
      formRows() {
        return this.form.content.rows
      },
      elementStyles() {
        return (new StylesParser(this.styles, this.device)).parse()
      },
      elementClasses() {
        return (new ConstantsParser(this.classes, this.device)).parse()
      },
      text: {
        get() {
          return this.content.text
        },
        set: _.debounce(function (value) {
          let element = this.mapElement({...this.content, text: value})
          this.addToObject('componentModule', {rows: element}, 'content', null, this.formElement)
        }, 1000)
      },
    },
    methods: {
      mapElement(newContent) {
        let newRows = Array.from(this.formRows).map(formRow => {
          if (this.formRowId != formRow.id) {
            return formRow
          }
          let formColumns = formRow.columns.map(formColumn => {
            if (this.formColumnId != formColumn.id) {
              return formColumn
            }
            let formComponents = formColumn.components.map(formComponent => {
              if (formComponent.id != this.id) {
                return formComponent
              }
              return {...formComponent, content: newContent}
            })
            return {...formColumn, components: formComponents}
          })
          return {...formRow, columns: formColumns}
        })
        return newRows
      }
    }
  }
</script>